// @file Store for user experiments
import {
  MakePageLayoutExistingUsersExperimentVariant,
  MakePageLayoutNewTeachersExperimentVariant,
  MakePageSimplifiedLayoutExperimentVariant,
  SelfServeFreeTrialExperimentVariant,
  SmartSuggestionsExperimentVariant,
} from '@@/enums'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export enum UpgradeModalCopyAExperimentVariant {
  Control = 'control',
  Variation = 'variation',
}

export enum UpgradeModalSingleStepExperimentVariant {
  Control = 'control',
  Variation = 'variation',
}

export const useExperimentsStore = defineStore('experiments', () => {
  // State
  /**
   * Experiment: `upgrade_modal_copy_a`
   */
  const upgradeModalCopyAExperimentVariant = ref<UpgradeModalCopyAExperimentVariant>(
    UpgradeModalCopyAExperimentVariant.Control,
  )

  const upgradeModalSingleStepExperimentVariant = ref<UpgradeModalSingleStepExperimentVariant>(
    UpgradeModalSingleStepExperimentVariant.Control,
  )

  const setUpgradeModalCopyAExperimentVariant = (
    upgradeModalCopyAExperimentVariantValue: UpgradeModalCopyAExperimentVariant | undefined,
  ): void => {
    upgradeModalCopyAExperimentVariant.value =
      upgradeModalCopyAExperimentVariantValue ?? UpgradeModalCopyAExperimentVariant.Control
  }

  const setUpgradeModalSingleStepExperimentVariant = (
    upgradeModalSingleStepExperimentVariantValue: UpgradeModalSingleStepExperimentVariant | undefined,
  ): void => {
    upgradeModalSingleStepExperimentVariant.value =
      upgradeModalSingleStepExperimentVariantValue ?? UpgradeModalSingleStepExperimentVariant.Control
  }

  /**
   * Experiment: `smart_suggestions_experiment`
   */
  const smartSuggestionsExperimentVariant = ref<SmartSuggestionsExperimentVariant>(
    SmartSuggestionsExperimentVariant.Control,
  )

  const setSmartSuggestionsExperimentVariant = (
    smartSuggestionsExperimentVariantValue: SmartSuggestionsExperimentVariant | undefined,
  ): void => {
    smartSuggestionsExperimentVariant.value =
      smartSuggestionsExperimentVariantValue ?? SmartSuggestionsExperimentVariant.Control
  }

  /**
   * Experiment: `make_page_layout_existing_users_experiment`
   */
  const makePageLayoutExistingUsersExperimentVariant = ref<MakePageLayoutExistingUsersExperimentVariant>(
    MakePageLayoutExistingUsersExperimentVariant.Control,
  )

  const setMakePageLayoutExistingUsersExperimentVariant = (
    makePageLayoutExistingUsersExperimentVariantValue: MakePageLayoutExistingUsersExperimentVariant | undefined,
  ): void => {
    makePageLayoutExistingUsersExperimentVariant.value =
      makePageLayoutExistingUsersExperimentVariantValue ?? MakePageLayoutExistingUsersExperimentVariant.Control
  }

  /**
   * Experiment: `make_page_layout_new_teachers_experiment`
   */
  const makePageLayoutNewTeachersExperimentVariant = ref<MakePageLayoutNewTeachersExperimentVariant>(
    MakePageLayoutNewTeachersExperimentVariant.Control,
  )

  const setMakePageLayoutNewTeachersExperimentVariant = (
    makePageLayoutNewTeachersExperimentVariantValue: MakePageLayoutNewTeachersExperimentVariant | undefined,
  ): void => {
    makePageLayoutNewTeachersExperimentVariant.value =
      makePageLayoutNewTeachersExperimentVariantValue ?? MakePageLayoutNewTeachersExperimentVariant.Control
  }

  /**
   * Experiment: `make_page_simplified_layout_experiment`
   */
  const makePageSimplifiedLayoutExperimentVariant = ref<MakePageSimplifiedLayoutExperimentVariant>(
    MakePageSimplifiedLayoutExperimentVariant.Control,
  )

  const setMakePageSimplifiedLayoutExperimentVariant = (
    makePageSimplifiedLayoutExperimentVariantValue: MakePageSimplifiedLayoutExperimentVariant | undefined,
  ): void => {
    makePageSimplifiedLayoutExperimentVariant.value =
      makePageSimplifiedLayoutExperimentVariantValue ?? MakePageSimplifiedLayoutExperimentVariant.Control
  }

  /**
   * Experiment: `self_serve_free_trial_experiment`
   */
  const selfServeFreeTrialExperimentVariant = ref<SelfServeFreeTrialExperimentVariant>(
    SelfServeFreeTrialExperimentVariant.Control,
  )

  const setSelfServeFreeTrialExperimentVariant = (
    selfServeFreeTrialExperimentVariantValue: SelfServeFreeTrialExperimentVariant | undefined,
  ): void => {
    selfServeFreeTrialExperimentVariant.value =
      selfServeFreeTrialExperimentVariantValue ?? SelfServeFreeTrialExperimentVariant.Control
  }

  return {
    // State
    upgradeModalCopyAExperimentVariant,
    upgradeModalSingleStepExperimentVariant,
    smartSuggestionsExperimentVariant,
    makePageLayoutExistingUsersExperimentVariant,
    makePageLayoutNewTeachersExperimentVariant,
    makePageSimplifiedLayoutExperimentVariant,
    selfServeFreeTrialExperimentVariant,

    // Action
    setUpgradeModalCopyAExperimentVariant,
    setUpgradeModalSingleStepExperimentVariant,
    setSmartSuggestionsExperimentVariant,
    setMakePageLayoutExistingUsersExperimentVariant,
    setMakePageLayoutNewTeachersExperimentVariant,
    setMakePageSimplifiedLayoutExperimentVariant,
    setSelfServeFreeTrialExperimentVariant,
  }
})
